import LibSampleRate from '@alexanderolsen/libsamplerate-js/dist/libsamplerate.worklet.js?raw';

const script = new Blob([LibSampleRate], { type: 'application/javascript' });
const src = URL.createObjectURL(script);
export const LibSampleRateSrc = src;
